export default __webpack_public_path__ + "static/media/ic_wales.9b3d7bf3.svg";